import { Component } from '@angular/core';
import { StreakerCentralStateService } from '../services/streaker-central-state.service';

@Component({ selector: 'app-central-stats', templateUrl: './central-stats.component.html', styleUrls: ['./central-stats.component.scss'] })
export class CentralStatsComponent {
    constructor(public state: StreakerCentralStateService) {}
    total(rows: {count: number}[]): number { return rows.reduce((sum, row) => sum + row.count, 0); }
    percent(value: number, total: number): number { return total > 0 ? Math.min(100, value / total * 100) : 0; }
}
